import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=34847512&lang=pug&"
import script from "./ProvidersList.vue?vue&type=script&lang=js&"
export * from "./ProvidersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports